import { adoptedStyleSheetsSupport } from "@otto-ec/otto-components-utils/utils/canIUse";
import { runtimeScope } from "./logger";

const log = runtimeScope.scope("shadow-styles-injector");

/**
 *
 *
 *
 *
 *
 *
 */
export type ShadowStylesInjector = (element: HTMLElement) => Promise<void>;

/**
 *
 *
 *
 */
export type LazyStyleModuleImport = () => Promise<typeof import("*?inline")>;

/**
 *
 *
 *
 *
 *
 */
const styleSheetCache = new WeakMap<typeof import("*?inline"), CSSStyleSheet>();

/**
 *
 *
 *
 *
 *
 */
const injectedRootsByModule = new WeakMap<typeof import("*?inline"), WeakSet<ShadowRoot>>();

/**
 *
 *
 *
 *
 *
 *
 */
const injectShadowStyles = (rootNode: ShadowRoot, css: typeof import("*?inline")): void => {
  let injectedRoots = injectedRootsByModule.get(css);
  if (!injectedRoots) {
    injectedRoots = new WeakSet();
    injectedRootsByModule.set(css, injectedRoots);
  }
  if (injectedRoots.has(rootNode)) return;
  injectedRoots.add(rootNode);

  try {
    if (adoptedStyleSheetsSupport) {
      let style = styleSheetCache.get(css);
      if (!style) {
        style = new CSSStyleSheet();
        /*                                                                           */
        style.replace(css.default);
        styleSheetCache.set(css, style);
      }

      rootNode.adoptedStyleSheets.push(style);
      return;
    }
  } catch (error) {
    log.warn("Error injecting shadow styles:", error);
  }

  /*                                                            */
  /*                        */
  const styleEl = document.createElement("style");
  styleEl.textContent = css.default;
  rootNode.appendChild(styleEl);
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const useShadowStylesInjector: (
  styles?: LazyStyleModuleImport | LazyStyleModuleImport[] | undefined,
) => ShadowStylesInjector = (styles) => {
  if (!styles) return async () => undefined;
  const entries = Array.isArray(styles) ? styles : [styles];

  /**
 *
 *
 *
 */
  const adoptedRoots = new WeakSet<ShadowRoot>();

  return async (element) => {
    const rootNode = element.getRootNode();
    if (!(rootNode instanceof ShadowRoot) || adoptedRoots.has(rootNode)) return;
    adoptedRoots.add(rootNode);

    /*                                                                          */
    /*                                                                        */
    /*                          */
    const cssModules = await Promise.all(entries.map((entry) => entry()));
    for (const css of cssModules) injectShadowStyles(rootNode, css);
  };
};
